// extracted by mini-css-extract-plugin
export default {"responseItemList":"ResponseItemList_responseItemList__aAaMs","responseItem":"ResponseItemList_responseItem__Z+lQ+"};